const sessionUrl = '/OxygenSessions/sessions'
const BOTSERVICESID = '_FFFFFFFFFFFFFF00001651912466881253_';

function sendAlert(data) {
  console.log("Got Send Alert Event : ", data);
  if(data.ClientID) {
    getTrackingInfo((err, trackingInfo) => {
      let Client = window.botStore.getClientByID(data.ClientID);
      console.log("Alert Client : ", Client);
      let request = {
        method : 'POST',
        type : "application/json",
        url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/sendAlert',
        data : { Event : data, Client : Client, Tracking : trackingInfo }
      };

      window.BotServices.httpRequest(request, (err, res) => {
        console.log("sendAlert Server Resp : ", res);
      });

      window.DevMgr.openMediaPlayer({ Event : data, Client : Client });
    });
  }
}

function getTrackingInfo(callback) {
  const propagator = window.LivingScript_0070.propagator;
  const guid = window.LivingScript_0070.guid;
  let trackingId = guid.generateSync();
  propagator.addPort({
      ComponentOID: BOTSERVICESID,
      PortType: 'Input',
      PortOID: trackingId
  }, (err, DefaultInputPort) => {
      console.log("Tracking Alert Added Port : "+DefaultInputPort);
      var defaultChannel = propagator.getDefaultChannel({
          ComponentOID: trackingId,
          ContainerOID: BOTSERVICESID
      });
      console.log("Tracking Listen to : Component :" + trackingId + " Container : " + BOTSERVICESID);
      propagator.listenToInputPort({
          InputPort: DefaultInputPort,
          Listener: (payload) => {
              console.log("Got Message by Alert :", payload);
              if(payload.Message && payload.Message.MessageType == 'AlertApi') {
                if(payload.Message.MessageBody && payload.Message.MessageBody.command) {
                  // if(payload.Message.MessageBody.command == "AnswerCall") {
                  //   window.BotServices.answerCall({ Event : payload.Message.MessageBody, Client : params });
                  // }
                }
              }
          }
      }, (err, res) => {
          propagator.subscribeToChannel({
              Channel: defaultChannel,
              InputPort: DefaultInputPort
          }, ()=>{
            callback(null, {trackingId : trackingId, Channel : defaultChannel});
          });
      });
  });
}

export {
  sendAlert
}
